<template>
  <aha-modal
    :title="$i18nPresenter.t('We’re developing it!')"
    @hide="hideModal"
  >
    <div class="tab-content pb-4">
      <img src="@/assets/images/team/on-going-creat-new-team.png" />
      <p class="my-4">
        {{ $i18nPresenter.t("Soon you'll be able to check participant’s attendance.") }}
      </p>
      <aha-button class="float-right mb-2" @click="emailMe">
        {{ $i18nPresenter.t("Email me when it’s ready") }}
      </aha-button>
    </div>
  </aha-modal>
</template>
<script>
import EventBus from '@/eventBus'
import utils from '@/util'

export default {
  data() {
    return {

    }
  },
  methods: {
    hideModal() {
      this.$emit('hide', { action: 'hide' })
    },
    emailMe() {
      const showAttendancePopupBefore = window.localStorage.getItem('showAttendancePopupBefore') || false
      if (!showAttendancePopupBefore) window.localStorage.setItem('showAttendancePopupBefore', true)
      utils.showToastSuccess(this.$i18nPresenter.t('Request received'))
      EventBus.$emit('check-attendance-add-participant-clicked')
      this.$emit('emailClickedTracker')
      this.$emit('hide', { action: 'email' })
    },
  },
}
</script>
<style scoped lang='scss'>

</style>
